import Svg, { ClipPath, Defs, G, Rect } from 'react-native-svg'

export const CardIcon = ({ height, width, color = '#d1e0ff' }: { height: any; width: any; color: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-Front" accessible={false} tabIndex={-1}>
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G id="Front" clipPath="url(#clip-Front)" accessible={false} tabIndex={-1}>
        <G id="Group_2" data-name="Group 2" transform="translate(-805 -387)" accessible={false} tabIndex={-1}>
          <Rect
            id="Rectangle_857"
            data-name="Rectangle 857"
            width="24"
            height="16"
            rx="2"
            transform="translate(809 395)"
            fill={color}
            accessible={false}
            tabIndex={-1}
          />
          <G id="Group_1" data-name="Group 1" accessible={false} tabIndex={-1}>
            {/* <Circle
              id="Ellipse_2"
              data-name="Ellipse 2"
              cx="2"
              cy="2"
              r="2"
              transform="translate(812 398)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            /> */}
            <Rect
              id="Rectangle_862"
              data-name="Rectangle 862"
              width="4"
              height="1"
              transform="translate(812 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_863"
              data-name="Rectangle 863"
              width="4"
              height="1"
              transform="translate(817 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_864"
              data-name="Rectangle 864"
              width="4"
              height="1"
              transform="translate(822 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_865"
              data-name="Rectangle 865"
              width="4"
              height="1"
              transform="translate(827 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
